import React, { useState } from "react";
import axiosInstance from "../config/axios";

const AddReminderForm = ({ onReminderAdded }) => {
  const [date, setDate] = useState("");
  const [reminder, setReminder] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!date || !reminder.trim()) {
      alert("Please fill out both fields.");
      return;
    }

    // If date is in YYYY-MM-DD format from date picker, parse it.
    // If it's empty, it's caught by the initial check.
    let dateToSend = "";
    if (date) {
      // date state now holds YYYY-MM-DD
      const parts = date.split("-");
      if (parts.length === 3) {
        // Reconstruct to DD/MM/YYYY for backend
        dateToSend = `${parts[2]}/${parts[1]}/${parts[0]}`;
      } else {
        // This case should ideally not happen if using date picker correctly
        alert("Invalid date selected from picker.");
        return;
      }
    } else {
      alert("Please select a date."); // Should be caught by earlier check too
      return;
    }

    try {
      await axiosInstance.post("/reminders", {
        date: dateToSend, // Send in DD/MM/YYYY format
        reminder: reminder.trim(),
      });

      setDate("");
      setReminder("");
      onReminderAdded(); // Call parent refresh handler
      alert("Reminder added successfully!");
    } catch (error) {
      console.error("Error adding reminder:", error);
      alert("Failed to add reminder.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-2 flex flex-col gap-2">
      <div>
        <label
          htmlFor="date"
          className="block text-xs font-medium text-gray-700 mb-0.5"
        >
          Date
        </label>
        <input
          type="date"
          id="date"
          name="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="border p-1.5 rounded w-full text-sm"
        />
      </div>
      <div>
        <label
          htmlFor="reminder"
          className="block text-xs font-medium text-gray-700 mb-0.5"
        >
          Reminder
        </label>
        <input
          type="text"
          id="reminder"
          name="reminder"
          placeholder="Enter Reminder"
          value={reminder}
          onChange={(e) => setReminder(e.target.value)}
          className="border p-1.5 rounded w-full text-sm"
        />
      </div>
      <button
        type="submit"
        className="bg-blue-900 text-white px-3 py-1.5 rounded hover:bg-blue-800 self-start text-sm"
      >
        Add Reminder
      </button>
    </form>
  );
};

export default AddReminderForm;
